import { abortableFetch, useEventCallback } from '@eas/common-web';
import { Proposer } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useEditProposerDialog() {
  const callApi = useEventCallback(
    (
      id: string,
      proposerId: string,
      formData: Proposer,
      updateClosed = false
    ) => {
      return abortableFetch(
        `${EvidenceApiUrl.ES_FILES}/${id}/participant/${proposerId}${
          updateClosed ? '/update-closed' : ''
        }`,
        {
          method: 'PUT',
          headers: new Headers({
            'Content-Type': 'application/json',
          }),
          body: JSON.stringify(formData),
        }
      );
    }
  );

  return {
    callApi,
  };
}
